import { EventSummaryDocument } from "./EventSummaryDocument";

export default EventSummaryDocument;
